export const ComponentType = {
  ANTI_CHURN_POPUP: "ANTI_CHURN_POPUP",
  ANNOUNCEMENT_BAR: "ANNOUNCEMENT_BAR",
  BLOG: "BLOG",
  BLOG_ARTICLE: "BLOG_ARTICLE",
  CP: "CP",
  MTO_APP: "MTO_APP",
  CP_LAZY: "CP_LAZY",
  CP_ADS: "CP_ADS",
  CP_OPTIONAL_PRODUCTS: "CP_OPTIONAL_PRODUCTS",
  CP_BYOB: "CP_BYOB",
  CP_BYOB_QUICKVIEW: "CP_BYOB_QUICKVIEW",
  CP_CARD: "CP_CARD",
  FLOATING_ATC: "FLOATING_ATC",
  FLOATING_ATC_ADS: "FLOATING_ATC_ADS",
  FOOTER: "FOOTER",
  HP: "HP",
  LUXE: "LUXE",
  PDP: "PDP",
  PDP_ADS: "PDP_ADS",
  PDP_QUICK_UPSELL: "PDP_QUICK_UPSELL",
  PRODUCT_CAROUSEL: "PRODUCT_CAROUSEL",
  PRODUCT_RECOMMENDATIONS: "PRODUCT_RECOMMENDATIONS",
  QUICKVIEW: "QUICKVIEW",
  REVIEWS: "REVIEWS",
  SEARCH: "Search",
  SIDE_CART: "SIDE_CART",
  SIDE_CART_UPSELL: "SIDE_CART_UPSELL",
  TIER_DISCOUNT_BOTTOM_BANNER: "TIER_DISCOUNT_BOTTOM_BANNER",
  TOP_PRODUCTS: "TOP_PRODUCTS",
  WISHLIST: "WISHLIST",
  MENU: "MENU",
  ORDER_HISTORY: "ORDER_HISTORY",
  404: "404",
};
